import { EGGSHELL_CREW, GREEN_CREW, Product, SOCKS,  } from '../products';

const whiteHatRecos: Product[] = [
    SOCKS,
    GREEN_CREW,
    EGGSHELL_CREW,
];

export default whiteHatRecos;